module.exports = (__webpack_require__(/*! dll-reference core_47817c160b152cbdef74 */ "dll-reference core_47817c160b152cbdef74"))("./utils/simulation.js");